<ng-container *ngIf="customTemplate; else defaultTemplate">
  <ng-container *ngTemplateOutlet="customTemplate"></ng-container>
</ng-container>
<ng-template #defaultTemplate>
  <p>shared-table works!</p>
</ng-template>
